<template>
	<div>
		<b-card>
			<template #header>
				<div class="card-header-title mt-1">
					<h5>{{ $t('restaurant.group') }}</h5>
				</div>
				<div class="card-header-actions">
					<b-input-group>
						<template #append>
							<b-input-group-text><strong class="fa fa-search" /></b-input-group-text>
							<b-button @click="createForm" variant="outline-primary" size="sm" class="mr-2 ml-3"
								style="font-size: 14px"><i class="fa fa-plus-circle" /></b-button>
						</template>
						<b-form-input v-model="search" />
					</b-input-group>
				</div>
			</template>
			<b-overlay :show="loading" rounded="sm">
				<table class="table table-bordered table-hover">
					<thead>
						<tr>
							<th class="text-center">{{ '№' }}</th>
							<th class="text-center">{{ $t('goods.name') }}</th>
							<th class="text-center">{{ $t('reference.code') }}</th>
							<th class="text-center">{{ $t('packageCode') }}</th>
							<th class="text-center">{{ $t('unitCode') }}</th>
							<th class="text-center">Статус</th>
							<th class="text-center">{{ $t('goods.actions') }}</th>
						</tr>
					</thead>
					<tbody v-if="items.length > 0">
						<tr v-for="(item, index) in items" :key="`group-${index}`">
							<td class="text-center pt-3">{{ index + 1 }}</td>
							<td class="text-center pt-3">{{ item.name }}</td>
							<td class="text-center pt-3">{{ item.code }}</td>
							<td class="text-center pt-3">{{ item.packageCode }}</td>
							<td class="text-center pt-3">{{ item.unitCode }}</td>
							<td class="text-center pt-3"><b-checkbox v-model="item.status" @change="activateGroup(item)"
									switch />
							</td>
							<td class="text-center pt-2" style="width: 10%">
								<b-button @click="editForm(item)" variant="outline-primary" size="sm"
									class="fa fa-pencil" />
							</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td class="text-center" colspan="5">{{ $t('empty') }}</td>
						</tr>
					</tbody>
				</table>
			</b-overlay>
		</b-card>

		<!--		Create / Edit		-->
		<b-modal v-model="createModal" :title="create ? $t('incomes.create.create') : $t('booking.edit')" centered
			no-close-on-backdrop hide-footer>
			<b-row>
				<b-col>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('goods.name') }}</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.name" type="text" />
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('reference.code') }}</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.code" type="text" />
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('packageCode') }}</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.packageCode" type="number" />
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('unitCode') }}</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.unitCode" />
					</b-input-group>
					<multiselect v-model="mxikCodeId" :options="mxikList" @search-change="getMxikList($event)"
						:custom-label="mxikCustomLabel" track-by="id" :show-labels="false" :allow-empty="true"
						placeholder="mxik" class="multiselect-pricing mt-3">
						<template slot="option" slot-scope="option">
							{{ mxikCustomLabel(option.option) }}
						</template>
					</multiselect>
				</b-col>
			</b-row>
			<hr>
			<div class="card-header-actions">
				<b-button @click="createModal = false" variant="outline-danger" class="mr-3" size="sm">{{ $t('cancel')
					}}</b-button>
				<b-button @click="save" variant="success" size="sm">{{ $t('save') }}</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import ReferencesService from "@/services/references.sevice";
import RestaurantGroupService from "./service/group.service";
import groupService from "./service/group.service";
import Multiselect from 'vue-multiselect'
import { BOverlay } from 'bootstrapVue2';

export default {
	name: "group",
	components: { BOverlay, Multiselect },
	data() {
		return {
			items: [],
			search: '',
			create: true,
			createModal: false,
			form: {},
			itemIndex: null,
			loading: false,
			mxikCodeId: null,
			mxikList: [],
		}
	},
	methods: {
		async getMxikList(keyword = '') {
			this.loading = true
			await ReferencesService.getMxikCodeList(keyword).then(res => {
				this.mxikList = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		mxikCustomLabel(mxik) {
			return (
				mxik.mxikCode +
				" / " +
				mxik.mxikNameRu +
				" / " +
				mxik.classNameRu +
				" / " +
				mxik.groupNameRu +
				" / " +
				mxik.positionNameRu
			);
		},
		getList() {
			this.loading = true
			RestaurantGroupService.listGroup(this.search).then(res => {
				this.items = res.data.items
				this.loading = false
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			})
		},
		createForm() {
			this.create = true
			this.form = {}
			this.form.name = ''
			this.form.code = ''
			this.form.unitCode = ''
			this.form.packageCode = ''

			this.form.status = true
			this.createModal = true
		},
		async editForm(item) {
			this.create = false
			this.form = Object.assign({}, item)
			if (item.mxikCodeId) {
				await ReferencesService.getByMxikId(item.mxikCodeId).then(res => {
					this.mxikList.unshift(res.data)
					this.mxikCodeId = res.data
				})
			} else {
				this.form.mxikCodeId = null
				this.mxikCodeId = null
			}
			this.createModal = true
		},
		async activateGroup(item) {
			this.loading = true
			item.status = !item.status
			await groupService.activeOrInactive(item).then(res => {
				this.$vs.notify({
					title: 'Success',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
				this.loading = false
				this.getList();
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		save() {
			if (this.form.name !== '' && this.form.code !== '' && this.form.packageCode !== '' && this.form.unitCode !== '' && this.mxikCodeId !== null) {
				this.loading = true

				const payload = {
					...this.form,
					mxikCodeId: this.mxikCodeId.id
				}

				if (this.create) {
					RestaurantGroupService.createGroup(payload).then(res => {
						this.createModal = false
						this.getList();
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else {
					RestaurantGroupService.updateGroup(this.form.id, payload).then(res => {
						this.createModal = false
						this.getList();
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				}
			} else {
				this.$vs.notify({
					title: this.$t('required_error'),
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		}
	},
	watch: {
		'search': {
			handler(e) {
				this.getList();
			}
		}
	},
	created() {
		this.getList();
	}
}
</script>

<style scoped>
.width12 {
	width: 8% !important;
}
</style>

<style scoped lang="scss">
.upload-wrapper {
	position: relative;
	overflow: hidden;
	border: 2px solid #e1e1e1;
	height: 200px;
	text-align: center;
}

.upload-wrapper i.fa {
	position: absolute;
	color: #e1e1e1;
	font-size: 50px;
	left: calc(50% - 25px);
	top: calc(50% - 25px)
}

.upload-wrapper input {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	opacity: 0;
}

.image-wrapper {
	position: relative;
	cursor: pointer;
}

.image-wrapper i.fa {
	position: absolute;
	right: 15px;
	color: #fff;
	top: 0;
	padding: 5px;
	border: 5px solid #08772f;
	background: #4dbd74;

	&.fa-close {
		border: .5px solid red;
		background: lightcoral;
	}
}
</style>
